/* YO&NO theme helpers */
(function(){
  function reveal(root){
    var els=(root||document).querySelectorAll('.yn-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  function tabs(root){
    (root||document).querySelectorAll('[data-yn-tabs]').forEach(function(w){
      if(w.dataset.ready)return;w.dataset.ready=1;
      var btns=w.querySelectorAll('[data-yn-tab]'),panels=w.querySelectorAll('[data-yn-panel]');
      btns.forEach(function(b){b.addEventListener('click',function(){
        btns.forEach(function(x){x.setAttribute('aria-selected',x===b)});
        panels.forEach(function(p){p.hidden=p.dataset.ynPanel!==b.dataset.ynTab});
        reveal(w);
      })});
    });
  }
  /* quick add for single-variant products (uses Dawn cart drawer when present) */
  document.addEventListener('submit',function(e){
    var f=e.target.closest('form[data-yn-quick]');if(!f)return;
    e.preventDefault();
    var btn=f.querySelector('button');btn.setAttribute('aria-busy','true');btn.disabled=true;
    var drawer=document.querySelector('cart-drawer');
    var fd=new FormData(f);
    if(drawer){fd.append('sections','cart-drawer,cart-icon-bubble');fd.append('sections_url',location.pathname);}
    fetch((window.routes&&window.routes.cart_add_url?window.routes.cart_add_url:'/cart/add')+'.js',{method:'POST',headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json()})
      .then(function(res){
        if(res.status){btn.textContent=res.description||'Niet beschikbaar';return;}
        if(drawer&&drawer.renderContents){drawer.classList.remove('is-empty');drawer.renderContents(res);}
        else{location.href=(window.routes&&window.routes.cart_url)||'/cart';}
        btn.classList.add('is-added');setTimeout(function(){btn.classList.remove('is-added')},2000);
      })
      .catch(function(){f.submit()})
      .finally(function(){btn.removeAttribute('aria-busy');btn.disabled=false;});
  });
  /* sticky add to cart on product pages */
  function sticky(){
    var bar=document.querySelector('[data-yn-sticky]');if(!bar)return;
    var main=document.querySelector('.product-form__submit');
    if(!main){bar.remove();return;}
    var io=new IntersectionObserver(function(en){bar.classList.toggle('is-visible',!en[0].isIntersecting&&en[0].boundingClientRect.top<0)});
    io.observe(main);
    bar.querySelector('button').addEventListener('click',function(){
      if(main.disabled){main.scrollIntoView({behavior:'smooth',block:'center'});return;}
      main.click();
    });
  }

  /* free-shipping progress (cart drawer + cart page) */
  var SHIP=2000,shipBusy=false;
  function eur(c){return (c/100).toLocaleString('nl-NL',{style:'currency',currency:'EUR'})}
  function shipHTML(cart){
    var t=cart.total_price,rest=SHIP-t,pct=Math.min(100,Math.round(t/SHIP*100));
    var msg=rest>0?'Nog <strong>'+eur(rest)+'</strong> tot gratis verzending.':'Je bestelling wordt <strong>gratis verzonden</strong>.';
    return '<div class="yn-ship" role="status">'+msg+'<div class="yn-ship__bar" aria-hidden="true"><span style="width:'+pct+'%"></span></div></div>';
  }
  function refreshShip(){
    if(shipBusy)return;shipBusy=true;
    fetch((window.routes&&window.routes.cart_url||'/cart')+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(cart){
      document.querySelectorAll('.yn-ship').forEach(function(e){e.remove()});
      if(cart.item_count>0){
        var h=document.querySelector('#CartDrawer .drawer__header');
        if(h){ h.insertAdjacentHTML('afterend',shipHTML(cart)); upsell(cart); }
        document.querySelectorAll('[data-yn-ship-slot]').forEach(function(s){s.innerHTML=shipHTML(cart)});
      }
    }).catch(function(){}).finally(function(){setTimeout(function(){shipBusy=false},150)});
  }

  /* cart drawer: suggest a small add-on that unlocks free shipping */
  var upCache=null;
  function upsell(cart){
    var rest=SHIP-cart.total_price, bar=document.querySelector('#CartDrawer .yn-ship');
    if(!bar||rest<=0) return;
    var inCart=cart.items.map(function(i){return i.product_id});
    (upCache?Promise.resolve(upCache):fetch('/collections/bestsellers/products.json?limit=30').then(function(r){return r.json()}).then(function(j){upCache=j.products;return upCache;})).then(function(ps){
      var c=ps.filter(function(p){ return p.variants.length===1&&p.variants[0].available&&inCart.indexOf(p.id)<0; })
        .map(function(p){ return {p:p,price:Math.round(parseFloat(p.variants[0].price)*100)}; })
        .sort(function(a,b){ var A=a.price>=rest, B=b.price>=rest; if(A!==B) return A?-1:1; return A?a.price-b.price:b.price-a.price; }).slice(0,3);
      if(!c.length||!document.body.contains(bar)||bar.querySelector('.yn-up')) return;
      var html='<div class="yn-up"><p class="yn-up__h">Misschien iets voor erbij?</p>'+c.map(function(x){
        var im=x.p.images&&x.p.images[0]?x.p.images[0].src:''; if(im) im+=(im.indexOf('?')>-1?'&':'?')+'width=160';
        return '<div class="yn-up__i">'+(im?'<img src="'+im+'" alt="" loading="lazy">':'')+'<span class="yn-up__t">'+x.p.title.replace(/</g,'&lt;')+'<em>'+eur(x.price)+'</em></span><button type="button" data-yn-up="'+x.p.variants[0].id+'" aria-label="'+x.p.title.replace(/"/g,'&quot;').replace(/</g,'&lt;')+' toevoegen">+</button></div>';
      }).join('')+'</div>';
      bar.insertAdjacentHTML('beforeend',html);
    }).catch(function(){});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-yn-up]'); if(!b) return;
    b.disabled=true; var drawer=document.querySelector('cart-drawer'), fd=new FormData();
    fd.append('id',b.dataset.ynUp); fd.append('quantity',1); fd.append('sections','cart-drawer,cart-icon-bubble'); fd.append('sections_url',location.pathname);
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'},body:fd}).then(function(r){return r.json()}).then(function(res){ if(res.status){ b.disabled=false; return; } if(drawer&&drawer.renderContents) drawer.renderContents(res); else location.reload(); }).catch(function(){b.disabled=false;});
  });
  function watchShip(){
    var d=document.getElementById('CartDrawer');
    if(d){new MutationObserver(function(){if(!d.querySelector('.yn-ship')&&!d.querySelector('.is-empty .drawer__header'))refreshShip()}).observe(d,{childList:true,subtree:true});}
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){subscribe(PUB_SUB_EVENTS.cartUpdate,function(){setTimeout(refreshShip,80)});}
    refreshShip();
  }
  function init(root){reveal(root);tabs(root);}
  document.addEventListener('DOMContentLoaded',function(){init();sticky();watchShip();});
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
